import { AxeToPlot } from "../../components/chart/filters/axes-to-plot-selector";
import { RoMembrane, RoMembraneAllowedPaths } from "../../omd-api/membranes/ro/ro-queries";

export const allAxesToPlot: AxeToPlot<RoMembrane, RoMembraneAllowedPaths>[] = [
    { axe: "data.a", axeSchema: 'membranes' },
    { axe: "data.ab", axeSchema: 'membranes' },
    { axe: "data.robs", axeSchema: 'membranes' },
    { axe: "data.rreal", axeSchema: 'membranes' },
]